<div class="bfsg-widget" [class.open]="toolbarVisible" [class.left]="widgetSide === 'left'" [class.right]="widgetSide === 'right'">
	<!-- Floating toggle button (desktop only) -->
	<button class="bfsg-toggle" *ngIf="!isMobile" (click)="toolbarVisible = !toolbarVisible" aria-label="Toggle Accessibility Panel">
		🛠
	</button>

	<!-- Panel -->
	<div class="bfsg-panel" *ngIf="toolbarVisible">
		<!-- Close button -->
		<button class="bfsg-close" aria-label="Close Accessibility Panel" (click)="toolbarVisible = false">×</button>

		<!-- Optional custom label -->
		<h3 class="bfsg-title" *ngIf="mobileLabel">{{ mobileLabel }}</h3>

		<!-- Feature buttons -->
		<div class="bfsg-grid">
			<button class="bfsg-button" (click)="bfsg.cycleFeature('textSize')">
				<span class="bfsg-icon">🔠</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.TEXT_SIZE' | translate }}</span>
				<span class="bfsg-state">{{ bfsg.getFeatureLabel('textSize') }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.cycleFeature('lineHeight')">
				<span class="bfsg-icon">📏</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.LINE_HEIGHT' | translate }}</span>
				<span class="bfsg-state">{{ bfsg.getFeatureLabel('lineHeight') }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.cycleFeature('contrast')">
				<span class="bfsg-icon">🎨</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.CONTRAST' | translate }}</span>
				<span class="bfsg-state">{{ bfsg.getFeatureLabel('contrast') }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.cycleFeature('saturation')">
				<span class="bfsg-icon">🎨</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.SATURATION' | translate }}</span>
				<span class="bfsg-state">{{ bfsg.getFeatureLabel('saturation') }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.toggleFeature('highlightLinks')">
				<span class="bfsg-icon">🔗</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.HIGHLIGHT_LINKS' | translate }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.toggleFeature('hideImages')">
				<span class="bfsg-icon">🖼️</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.HIDE_IMAGES' | translate }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.toggleFeature('pauseAnimation')">
				<span class="bfsg-icon">⏸️</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.PAUSE_ANIMATION' | translate }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.toggleFeature('dyslexicFont')">
				<span class="bfsg-icon">📚</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.DYSLEXIC_FONT' | translate }}</span>
			</button>

			<button class="bfsg-button" (click)="bfsg.toggleFeature('bigCursor')">
				<span class="bfsg-icon">➕</span>
				<span class="bfsg-label">{{ 'ACCESSIBILITY.BIG_CURSOR' | translate }}</span>
			</button>
		</div>

		<!-- Widget Position Switch -->
		<div class="bfsg-switch-row">
			<label class="bfsg-switch-label">{{ 'ACCESSIBILITY.POSITION' | translate }}</label>
			<label class="bfsg-switch">
				<input type="checkbox" [checked]="widgetSide === 'right'" (change)="toggleSide()" aria-label="switch widget Position" />
				<span class="bfsg-slider"></span>
			</label>
		</div>

		<!-- Reset Button -->
		<button class="bfsg-reset" (click)="bfsg.resetAllStyles()">
			{{ 'ACCESSIBILITY.RESET' | translate }}
		</button>

		<!-- Language Switch -->
		<div class="bfsg-language-select">
			<select (change)="onLangChange($event)">
				<option value="de">🇩🇪 Deutsch</option>
				<option value="en">🇬🇧 English</option>
			</select>
		</div>
	</div>
</div>
